<template>
  <footer class="warning-bg mb-0 mt-auto">
    <v-container>
      <v-row justify="center">
        <v-col md="6">
          <v-list class="mt-0 warning-bg">
            <v-list-item v-for="req in requisites" :key="req.id" class="text-white text-subtitle-2 text-sm-body-1">{{ req.title }}</v-list-item>
          </v-list>
        </v-col>
        <v-col md="6">
          <v-list class="mt-0 warning-bg">
            <v-list-item v-for="menu in footer_menu" :key="menu.id" class="pa-0 text-subtitle-2 text-sm-body-1">
              <router-link :to="menu.link" class="text-white text-decoration-none">{{ menu.title }}</router-link>
            </v-list-item>
          </v-list>
          <v-btn class="align-center text-white ml-0 mr-auto d-block mt-5 support_btn">
            <a href="https://qr.nspk.ru/AS2A005RR68CQSD39JVB59RUD13DLHI5?type=01&bank=100000000111&crc=5547"
               class="text-decoration-none text-white">Поддержать</a></v-btn>
          <section class="social-links mt-8 position-relative">
            <a href="https://vk.com/anootvet.vopros" target="_blank" rel="noopener" aria-label="ВКонтакте">
              <v-icon class="warning" size="50">mdi-vk</v-icon>
            </a>
            <a
                href="https://max.ru/u/f9LHodD0cOLgT5mdo0rvTsMadDxi4oApeMXY9ekDmOIESUHJO-C55euXevg"
                target="_blank"
                rel="noopener"
                class="max-link"
                aria-label="Max"
            >
              <img :src="maxIcon" class="max-icon" alt="Max" />
            </a>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {
  data: () => ({
    maxIcon: require('@/assets/MAX.svg'),
    requisites:
      [
        { title: '© 2025. 0+', id: 0 },
        { title: 'АНО Ответ', id: 1 },
        { title: 'ИНН 4214041570', id: 2 },
        { title: 'КПП 421401001', id: 3 },
        { title: 'ОГРН 1214200006162', id: 4 },
        { title: 'БИК 040173604', id: 5 },
        { title: 'К/С 30101810200000000604', id: 6 },
        { title: 'Р/С 40703810502740000094', id: 7 },
        { title: 'Банк: "АЛТАЙСКОЕ ОТДЕЛЕНИЕ N8644 ПАО СБЕРБАНК", адрес: г. Барнаул, ул. Попова, д. 73а', id: 8 }
      ],
    footer_menu:
      [
        { title: 'Политика конфиденциальности', id: 0, link: '/policy' },
        { title: 'Оферта о благотворительном пожертвовании', id: 1, link: '/offer' },
        { title: 'Тел: +7 (923) 003-38-74', id: 2, link: 'tel://+79230033874' },
        { title: 'E-mail: anootvet2025@gmail.com', id: 3, link: 'mailto:anootvet2025@gmail.com' },
        { title: 'E-mail: ano_otvet2025@mail.ru', id: 5, link: 'mailto:ano_otvet2025@mail.ru' },
        { title: 'Фактический адрес: Алтайский край, г. Барнаул, пр-т Космонавтов, д. 12/7, 2 этаж', id: 4, link: '' }
      ]
  })
}
</script>

<style scoped lang="sass">
.warning-bg
  background-color: #5CBBF6
  margin-top: auto

.support_btn
  background-color: #fc7b23

.social-links
  display: flex
  align-items: center
  gap: 14px

  a
    display: inline-flex
    align-items: center
    justify-content: center
    text-decoration: none

.max-icon
  width: 50px
  height: 50px
  display: block
  object-fit: contain
</style>
